export default {
  path: 'emails',
  name: 'emails',
  redirect: { name: 'emails.index' },
  children: [
    {
      path: '',
      name: 'emails.index',
      component: () => import('pages/emails/IndexPage.vue'),
    },
  ],
}
